import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiUrls } from 'src/app/core/classes/ApiUrls';
import { Helper } from 'src/app/shared/classes/Helper';
import { HitApi } from 'src/app/shared/classes/HitApi';
import { Widget } from 'src/app/shared/classes/Widget';
import { WidgetInjectedData } from 'src/app/shared/classes/WidgetInjectedData';
import { AuthorizationType } from 'src/app/shared/enums/AuthorizationType';
import { ButtonColorType } from 'src/app/shared/enums/ButtonColorType';
import { ButtonType } from 'src/app/shared/enums/ButtonType';
import { FilterStoreKey } from 'src/app/shared/enums/FilterStoreKey';
import { IconType } from 'src/app/shared/enums/IconType';
import { ModalAction } from 'src/app/shared/enums/ModalAction';
import { ModalType } from 'src/app/shared/enums/ModalType';
import { RequestType } from 'src/app/shared/enums/RequestType';
import { IHitApi } from 'src/app/shared/interfaces/hit-api/IHitApi';
import { IModalData } from 'src/app/shared/interfaces/modal/IModalData';
import { IButtonData } from 'src/app/shared/interfaces/table-generator/IButtonData';
import { HttpService } from 'src/app/shared/services/http/http-main/http.service';
import { ModalService } from 'src/app/shared/services/modal/modal-service/modal.service';
import { NotificationsService } from 'src/app/shared/services/notifications/notifications.service';
import { AutomationModalConfigureNotificationComponent } from '../../../modal-templates/automation-modal-steps/automation-modal-configure-notification/automation-modal-configure-notification.component';
import { AutomationModalFiltersComponent } from '../../../modal-templates/automation-modal-steps/automation-modal-filters/automation-modal-filters.component';
import { AutomationModalSchedulerComponent } from '../../../modal-templates/automation-modal-steps/automation-modal-scheduler/automation-modal-scheduler.component';
import { IButtonGeneratorInput } from './../../../../interfaces/button-generator/IButtonGeneratorInput';
import { ICardsGeneratorInput } from './../../../../interfaces/card-generator/ICardsGeneratorInput';

@Component({
    selector: 'app-automation-listing',
    templateUrl: './automation-listing.component.html',
    styleUrls: ['./automation-listing.component.sass']
})
export class AutomationListingComponent implements OnInit {
    widgetRef: Widget;
    cardInput: ICardsGeneratorInput;
    constructor(
        widgetData: WidgetInjectedData,
        private modalService: ModalService,
        private notificationService: NotificationsService,
        private httpService: HttpService
    ) {
        this.widgetRef = widgetData.widgetRef;
    }

    ngOnInit(): void {
        this.cardInput = {
            noDataMessage: 'No rules available',
            cardTitle: {
                infoTitle: 'Automation Name',
                infoKey: 'automationName'
            },
            infoData: [
                {
                    infoTitle: 'Created By',
                    infoKey: 'createdBy|email'
                },
                {
                    infoTitle: 'Next Scheduled Date',
                    infoKey: 'nextSchedulerDate'
                }
            ],
            buttons: [
                {
                    buttonName: null,
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-plus'
                    },
                    buttonType: ButtonType.ICON,
                    buttonColorType: ButtonColorType.PRIMARY,
                    hoverText: 'Create New Rule',
                    function: (buttonRef: IButtonGeneratorInput) => {
                        this.create();
                    }
                }
            ],
            cardButtons: [
                {
                    buttonName: null,
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-play'
                    },
                    buttonType: ButtonType.ICON,
                    buttonColorType: ButtonColorType.SECONDARY,
                    hoverText: 'Play',
                    showLoader: true,
                    function: (buttonRef: IButtonGeneratorInput, cardData) => {
                        buttonRef.loader = true;
                        this.play(cardData, buttonRef);
                    }
                },
                {
                    buttonName: null,
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-edit'
                    },
                    buttonType: ButtonType.ICON,
                    buttonColorType: ButtonColorType.SECONDARY,
                    hoverText: 'Edit Rule',
                    function: (buttonRef: IButtonGeneratorInput, cardData) => {
                        this.update(cardData);
                    },
                    showLoader: false
                },
                {
                    buttonName: null,
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-trash'
                    },
                    buttonType: ButtonType.ICON,
                    buttonColorType: ButtonColorType.WARN,
                    hoverText: 'Delete Rule',
                    function: (buttonRef: IButtonGeneratorInput, cardData) => {
                        this.delete(cardData);
                    },
                    showLoader: false
                }
            ],
            titleActions: [
                {
                    buttonName: null,
                    showLoader: true,
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-power-off'
                    },
                    ngStyleRenderer: (cardData) => {
                        return { color: cardData.active ? 'green' : 'red' };
                    },
                    hoverTextRenderer: (cardData) => {
                        return cardData.active ? 'Disable Rule' : 'Enable Rule';
                    },
                    function: (buttonRef: IButtonGeneratorInput, cardData) => {
                        buttonRef.loader = true;
                        this.toggleScheduler(cardData, buttonRef);
                    }
                }
            ],
            listExtraction: {
                type: 'DIRECT'
            },
            bulkActions: [
                {
                    buttonName: 'Delete',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-trash'
                    },
                    buttonType: ButtonType.ICON,
                    buttonColorType: ButtonColorType.WARN,
                    hoverText: 'Delete Selected Reports',
                    showLoader: true,
                    function: (
                        buttonData: IButtonData,
                        selectedCards,
                        bulkLoader: BehaviorSubject<boolean>
                    ) => {
                        this.modalService.openConfirmationModal({
                            modalName: 'Delete Rules',
                            modalIcon: {
                                type: IconType.FONTAWSOME,
                                class: 'fas fa-trash'
                            },
                            contextIcon: {
                                type: IconType.FONTAWSOME,
                                class: 'fas fa-exclaimation-triangle'
                            },
                            confirmationMessage:
                                'Are you sure you want to delete selected rules ?',
                            buttonColorType: ButtonColorType.WARN,
                            buttonText: 'Delete',
                            loaderOnExec: true,
                            function: (
                                modalId: Symbol,
                                formGroupRef,
                                buttonRef: IButtonData
                            ) => {
                                bulkLoader.next(true);
                                // Bulk Delete
                                const batchDeleteInput = {
                                    ids: selectedCards.map(
                                        (selCard) => selCard.id
                                    )
                                };
                                const apiArgs: IHitApi = {
                                    url: `${ApiUrls.AUTOMATION_ENDPOINT}/batch/widgetId/${this.widgetRef.widgetData.widgetId}`,
                                    intactUrl: `${ApiUrls.AUTOMATION_ENDPOINT}/{batch}/{widgetId}/`,
                                    input: batchDeleteInput,
                                    uniqueIdentity: Symbol(),
                                    requestType: RequestType.DELETE,
                                    config: {
                                        authorization:
                                            AuthorizationType.BEARER_TOKEN
                                    },
                                    function: (response) => {
                                        buttonRef.loader = false;
                                        this.widgetRef.notificationsService.showSnackBar(
                                            'Rules deleted successfully'
                                        );
                                        bulkLoader.next(false);
                                        this.widgetRef.refreshWidget();
                                    },
                                    errorFunction: (error) => {
                                        bulkLoader.next(false);
                                        buttonRef.loader = false;
                                        this.widgetRef.notificationsService.showSnackBar(
                                            error &&
                                                error.error &&
                                                error.error.message
                                                ? error.error.message
                                                : 'Error deleting rules',
                                            true
                                        );
                                        this.widgetRef.refreshWidget();
                                    }
                                };
                                this.widgetRef.modalService.closeModal(
                                    null,
                                    modalId
                                );
                                new HitApi(
                                    apiArgs,
                                    this.widgetRef.httpService,
                                    this.widgetRef.ngZone
                                ).hitApi();
                            }
                        });
                    }
                }
            ],
            selection: 'multiple'
        };
    }

    create() {
        const modalInfo = {
            label: this.widgetRef.widgetData.widgetInfo.text,
            purpose: ModalAction.CREATE
        };
        this.setModalDataAndOpen(modalInfo, null);
    }

    update(item) {
        const modalInfo = {
            label: this.widgetRef.widgetData.widgetInfo.text,
            purpose: ModalAction.UPDATE
        };
        this.setModalDataAndOpen(modalInfo, item);
    }

    setModalDataAndOpen(modalInfo, stepData) {
        this.widgetRef.filterService.filtersDataTemp.delete(
            FilterStoreKey.AUTOMATION_FILTERS
        );
        this.widgetRef.filterService.filtersData.delete(
            FilterStoreKey.AUTOMATION_FILTERS
        );
        this.widgetRef.hideLogicalOperatorRadioButtons = true;
        const modalData: IModalData = {
            modalName: modalInfo.label,
            modalAutoHeight: true,
            modalWidthVw: 60,
            modalIcon: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-laptop-code'
            },
            sourceId: this.widgetRef.widgetData.widgetUniqueIdentifier,
            modalType: ModalType.MIDDLE,
            modalPurpose: modalInfo.purpose,
            modalSteps: [
                {
                    stepData: {
                        componentToLoad: AutomationModalFiltersComponent,
                        payload: {
                            data: {
                                widgetRef: this.widgetRef,
                                stepData,
                                edit: stepData ? true : false
                            }
                        }
                    },
                    stepName: 'Filters'
                },
                {
                    stepData: {
                        componentToLoad: AutomationModalSchedulerComponent,
                        payload: {
                            data: {
                                widgetRef: this.widgetRef,
                                stepData,
                                edit: stepData ? true : false
                            }
                        }
                    },
                    stepName: 'Scheduler'
                },
                {
                    stepData: {
                        componentToLoad:
                            AutomationModalConfigureNotificationComponent,
                        payload: {
                            data: {
                                widgetRef: this.widgetRef,
                                stepData,
                                edit: stepData ? true : false
                            }
                        }
                    },
                    stepName: 'Configure Notification'
                }
            ]
        };
        this.modalService.openModal(modalData);
    }

    delete(item) {
        this.modalService.openConfirmationModal({
            modalName: 'Delete Rule',
            modalIcon: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-trash'
            },
            contextIcon: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-exclaimation-triangle'
            },
            confirmationMessage: 'Are you sure you want to delete rule ?',
            buttonColorType: ButtonColorType.WARN,
            buttonText: 'Delete',
            loaderOnExec: true,
            function: (modalId: Symbol) => {
                this.deleteApi.call(this, item, modalId);
            }
        });
    }

    deleteApi(item, modalId: Symbol) {
        const deleteArgs = Helper.generateHitApiConfig(
            this.widgetRef.widgetData.widgetInfo.delete
        );
        deleteArgs.intactUrl = deleteArgs.url;
        deleteArgs.url = deleteArgs.url.replace(
            '{widgetId}',
            this.widgetRef.widgetData.widgetId
        );
        deleteArgs.url = deleteArgs.url.replace('{automation-id}', item.id);
        deleteArgs.input = {};
        deleteArgs.function = (response) => {
            this.notificationService.showSnackBar('Rule deleted successfully');
            this.modalService.closeModal(null, modalId);
            this.widgetRef.refreshWidget();
        };
        deleteArgs.errorFunction = (error) => {
            this.notificationService.showSnackBar(
                error && error.error
                    ? error.error.message
                    : 'Error while deleting rule',
                true
            );
            this.modalService.closeModal(null, modalId);
            this.widgetRef.refreshWidget();
        };
        new HitApi(
            deleteArgs,
            this.widgetRef.httpService,
            this.widgetRef.ngZone
        ).hitApi();
    }

    play(item, buttonRef: IButtonGeneratorInput) {
        const widgetRef: Widget = this.widgetRef;

        const apiConfig: IHitApi = Helper.generateHitApiConfig(
            widgetRef.widgetData.widgetInfo.action
        );

        apiConfig.function = (response) => {
            buttonRef.loader = false;
            this.widgetRef.changeDetectorRef.detectChanges();
            this.notificationService.showSnackBar(
                'Your request has been initiated.'
            );
        };

        apiConfig.errorFunction = (error) => {
            buttonRef.loader = false;
            this.widgetRef.changeDetectorRef.detectChanges();
            Helper.showErrorMessage(
                this.widgetRef.notificationsService,
                error,
                'Error performing action'
            );
        };

        apiConfig.input = {
            automationName: item.automationName,
            automationFilter: item.automationFilter,
            widgetFilter: item.widgetFilter
        };

        new HitApi(apiConfig, widgetRef.httpService, widgetRef.ngZone).hitApi();
    }

    toggleScheduler(item: any, buttonRef: IButtonData): void {
        let status = '';
        if (item.active) {
            status = 'disable';
        } else {
            status = 'enable';
        }
        const widgetRef: Widget = this.widgetRef;
        const apiArgs: IHitApi = {
            url: item.active
                ? `${ApiUrls.DISABLE_RULE.replace(
                      '{widget-id}',
                      this.widgetRef.widgetData.widgetId
                  )}/${item.id}`
                : `${ApiUrls.ENABLE_RULE.replace(
                      '{widget-id}',
                      this.widgetRef.widgetData.widgetId
                  )}/${item.id}`,
            requestType: RequestType.PATCH,
            intactUrl: item.active
                ? `${ApiUrls.DISABLE_RULE.replace(
                      '{widget-id}',
                      this.widgetRef.widgetData.widgetId
                  )}/{automation-id}`
                : `${ApiUrls.ENABLE_RULE.replace(
                      '{widget-id}',
                      this.widgetRef.widgetData.widgetId
                  )}/{automation-id}`,
            input: {
                active: item.active ? false : true,
                automationFilter: item.automationFilter,
                automationName: item.automationName,
                widgetFilter: item.widgetFilter
            },
            function: (response) => {
                item.active = !item.active;
                buttonRef.loader = false;
            },
            errorFunction: (error) => {
                Helper.showErrorMessage(
                    this.widgetRef.notificationsService,
                    error,
                    'Error performing action'
                );
                buttonRef.loader = false;
                this.widgetRef.refreshWidget();
            },
            uniqueIdentity: Symbol(),
            config: {
                authorization: AuthorizationType.BEARER_TOKEN,
                ignoreBaseUrl: false
            }
        };
        new HitApi(apiArgs, widgetRef.httpService, widgetRef.ngZone).hitApi();
    }
}
